
export const FAQ_FAQ_INDEX_SET_DATA = 'FAQ_FAQ_INDEX_SET_DATA';

export const FAQ_FAQ_QUESTION_SET_DATA = 'FAQ_FAQ_QUESTION_SET_DATA';
export const FAQ_FAQ_QUESTION_RESET_DATA = 'FAQ_FAQ_QUESTION_RESET_DATA';
